// extracted by mini-css-extract-plugin
export default {"cwmodal_item":"ModalItem_cwmodal_item__9TvUH","icon":"ModalItem_icon__fgNZ3","focus":"ModalItem_focus__rmCUd"};